/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_OCC_MOVEMENTS_ITEM = {
  id: 'movements',
  screenId: 'fin-occ-movements',
  label: 'Movimientos',
  description: 'Compras pagadas con tarjetas propias.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá ves todo lo que se pagó con tarjetas de la empresa: cada cargo que se generó al registrar un pago con medio «tarjeta propia».',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Tarjeta', description: 'Opcional. Dejá «Todas» o elegí una tarjeta.' },
          { label: 'Desde / Hasta', description: 'Opcional. Filtra por fecha de compra. Por defecto muestra los últimos 90 días.' },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Fecha de compra, Tarjeta, Descripción, Proveedor, Recibo, Monto y cantidad de cuotas.',
          'Tocá una fila para ver el detalle del cargo y cómo quedó cada cuota (si ya está en un resumen o sigue pendiente).',
        ],
      },
      {
        title: 'De dónde salen',
        paragraphs: [
          'Los movimientos no se cargan acá. Se crean cuando registrás un pago en Administración → Pagos con forma de pago «tarjeta propia».',
        ],
      },
    ],
  },
}
